import { Button } from '@massilia/ui'
import { Link } from '@tanstack/react-router'
import { AlertTriangle, RefreshCw } from 'lucide-react'

interface FlightErrorCardProps {
  onRetry?: () => void
}

export function FlightErrorCard({ onRetry }: FlightErrorCardProps) {
  return (
    <div className="flex flex-col items-center justify-center rounded-xl border border-gray-200 bg-white px-8 py-12 shadow-sm">
      <div className="mb-6 flex h-20 w-20 items-center justify-center rounded-full bg-red-50">
        <AlertTriangle className="h-10 w-10 text-red-500" />
      </div>

      <h2 className="mb-2 text-xl font-semibold text-gray-900">Erreur de recherche</h2>

      <p className="mb-6 max-w-md text-center text-gray-600">
        Une erreur est survenue lors de la recherche de vols. Cela peut être dû à un problème
        temporaire du serveur ou à une connexion instable.
      </p>

      <div className="mb-8 rounded-lg bg-red-50 p-4">
        <p className="mb-3 text-sm font-medium text-red-700">Que faire ?</p>
        <ul className="space-y-2 text-sm text-red-600">
          <li className="flex items-start gap-2">
            <RefreshCw className="mt-0.5 h-4 w-4 shrink-0 text-red-400" />
            <span>Réessayez dans quelques instants</span>
          </li>
          <li className="flex items-start gap-2">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-red-400" />
            <span>Vérifiez votre connexion internet</span>
          </li>
          <li className="flex items-start gap-2">
            <AlertTriangle className="mt-0.5 h-4 w-4 shrink-0 text-red-400" />
            <span>Si le problème persiste, contactez le support</span>
          </li>
        </ul>
      </div>

      <div className="flex gap-3">
        {onRetry && (
          <Button
            className="border-red-200 text-red-600 hover:bg-red-50"
            onClick={onRetry}
            variant="outline"
          >
            <RefreshCw className="size-4" />
            Réessayer
          </Button>
        )}
        <Link to="/research-bar">
          <Button className="bg-brand-600 hover:bg-brand-700">
            <AlertTriangle className="size-4" />
            Nouvelle recherche
          </Button>
        </Link>
      </div>
    </div>
  )
}
